import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-executive-form',
  templateUrl: './business-executive-form.component.html',
  styleUrls: ['./business-executive-form.component.css']
})
export class BusinessExecutiveFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
